import { __decorate } from 'tslib';
import { MaskService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCTransferDataComponent = class UiCTransferDataComponent {
    constructor(maskService) {
        this.maskService = maskService;
        this.clickEvt = new EventEmitter();
        this.toggleChecked = new EventEmitter();
    }
    ngOnInit() {
    }
    choseAccount() {
        this.clickEvt.emit();
    }
    formatAccountBank(account) {
        return this.maskService.formatAccountBank(account);
    }
    checkedToggle($event) {
        this.toggleChecked.emit($event.detail.checked);
    }
};
UiCTransferDataComponent.ctorParameters = () => [
    { type: MaskService }
];
__decorate([
    Input()
], UiCTransferDataComponent.prototype, "transferData", void 0);
__decorate([
    Output()
], UiCTransferDataComponent.prototype, "clickEvt", void 0);
__decorate([
    Output()
], UiCTransferDataComponent.prototype, "toggleChecked", void 0);
__decorate([
    Input()
], UiCTransferDataComponent.prototype, "showToggle", void 0);
UiCTransferDataComponent = __decorate([
    Component({
        selector: 'ui-c-transfer-data',
        template: "<div class=\"details-account\" >\n  <ion-row>\n    <ion-col>\n      <ion-text (click)=\"choseAccount()\">\n        <p class=\"ion-text name font-size-17 ion-no-margin ion-margin-top ion-padding-horizontal\">\n          {{transferData.name}}\n        </p>\n        <p class=\"ion-text font-size-17 ion-no-margin ion-margin-top ion-padding-horizontal\">\n          {{transferData.bank}}\n        </p>\n        <p class=\"ion-text font-size-14 ion-no-margin ion-margin-bottom ion-padding-horizontal\">\n          {{'CASH_OUT.TRANSFER_ON_US.BANK_INFO.AGENCY' | wlpTranslate}} {{transferData.branch}}\n          {{'CASH_OUT.TRANSFER_ON_US.BANK_INFO.ACCOUNT' | wlpTranslate}}\n          {{formatAccountBank(transferData.accountNumber)}}\n        </p>\n      </ion-text>\n      <ion-text *ngIf=\"showToggle\"> \n        <div class=\"div-toggle d-flex align-items-center space-between\">\n          <p class=\"mt-2 text-card ion-text font-size-14 ion-no-margin ion-margin-bottom ion-padding-horizontal\">Deseja\n            guardar nos favoritos?</p>\n          <ion-toggle mode=\"ios\" (ionChange)=\"checkedToggle($event)\" color=\"success\" [(ngModel)]=\"toogleFavorite\">\n          </ion-toggle>\n        </div>\n      </ion-text>\n    </ion-col>\n\n    <div class=\"ion-icon ion-padding-end\">\n      <div>\n        <ion-icon class=\"ion-icon ion-no-padding\" size=\"small\" name=\"chevron-forward-outline\">\n        </ion-icon>\n      </div>\n    </div>\n  </ion-row>\n</div>",
        styles: [""]
    })
], UiCTransferDataComponent);

let UiCTransferDataModule = class UiCTransferDataModule {
};
UiCTransferDataModule = __decorate([
    NgModule({
        declarations: [UiCTransferDataComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiBsTranslateModule,
            UiBsUtilModule,
            FormsModule
        ],
        exports: [UiCTransferDataComponent]
    })
], UiCTransferDataModule);

/*
 * Public API Surface of ui-c-transfer-data
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCTransferDataComponent, UiCTransferDataModule };
//# sourceMappingURL=wlp-ui-c-transfer-data.js.map
